import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "../../components/Button";
import { HiHome } from "react-icons/hi";
import logo from "../../assets/sent_email.png";

const ForgotPasswordSent: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || "your email";

  const handleReturn = () => {
    navigate("/login");
  };

  const handleResend = () => {
    navigate("/forgot-password");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-0">
      <div className="w-full max-w-[600px] mx-auto px-8 py-12">
        <div className="w-full">
          <div className="flex justify-center items-center">
            <img
              src={logo}
              alt="Email sent"
              className="w-40 h-40 object-contain"
            />
          </div>

          <p className="text-sm text-center my-10 leading-5">
            パスワード再設定用のリンクを {email} に送信しました。
            <br />
            メールボックスをご確認ください。
          </p>

          <Button
            type="button"
            buttonType="primary"
            className="text-[15px] !px-6 py-2.5 !h-12 w-1/5 mx-auto block"
            onClick={handleReturn}
          >
            <span className="flex items-center justify-center gap-3">
              <HiHome className="text-xl text-white" />
              <p className="text-sm-plus font-bold leading-6.5">戻る</p>
            </span>
          </Button>

          <Button
            type="button"
            buttonType="link"
            className="text-sm-plus font-bold !p-2.5 mt-4 mx-auto"
            onClick={handleResend}
          >
            再送信する
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordSent;
